import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {QueryKeyName, addComment} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'
import {usePlantUpmId} from '../usePlantUpmIdContext'

interface AddCommentArgs {
  questionId: string
  comment: string
}

export const useAddComment = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({questionId, comment}: AddCommentArgs) =>
      addComment({plantId, questionId, comment}),
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetComments]})
      spawnSuccessToast(t('comments.added.success'))
    },
    onError: () => {
      spawnErrorToast(t('comments.added.error'))
    }
  })
}
